<template>
  <div class="file-context">
    <div class="file-head">
      <ul>
        <li v-for="(item, index) in fileList" :key="index" :class="{ checked: item.isChecked }" @click="setFile(item)">
          {{ item.fileName }}
        </li>
      </ul>
    </div>
    <div class="file-box">
      <PdfH5 :pdfUrl="fileDownloadUrl" :withCredentials="false"></PdfH5>
    </div>
  </div>
</template>
<script>
import PdfH5 from '@/components/PdfH5'

export default {
  components: {
    PdfH5,
  },

  data() {
    return {
      fileList: [],
      fileDownloadUrl: '',
    }
  },
  methods: {
    viewContractFile() {
      this.$ajax(this.$url.viewContractFile(this.$route.query.contractId), {}).then(res => {
        this.fileList = res.data || []
        this.fileList.forEach(item => {
          this.$set(item, 'isChecked', false)
        })
        this.fileList[0].isChecked = true
        this.fileDownloadUrl = this.fileList[0].fileDownloadUrl
      })
    },
    setFile(file) {
      this.fileList.forEach(item => {
        item.isChecked = false
      })
      file.isChecked = true
      this.fileDownloadUrl = file.fileDownloadUrl
    },
  },
  created() {
    this.viewContractFile()
  },
}
</script>
<style lang="less" scoped>
.file-context {
  position: fixed;
  width: 100%;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
}
.file-box {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.file-head {
  font-size: 15px;
  color: rgba(0, 0, 0, 1);
  line-height: 44px;
  padding: 0 25px;
  overflow: auto;
  white-space: nowrap;
  background: #fafafa;
  text-overflow: ellipsis;
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.1);
  background: #fff;
  ul {
    display: flex;
    font-size: 14px;
    overflow: auto;
  }
  ul::-webkit-scrollbar {
    display: none;
  }
  li {
    padding: 0 10px;
    border-bottom: 1px solid #b3b3b3;
  }
  .checked {
    font-weight: 500;
    font-size: 15px;
    border-bottom: 2px solid #e63740;
  }
}
</style>
